import prettyBytes from "pretty-bytes"

export const useFileUploadValidation = () => {
  const config = useRuntimeConfig()
  const { isSuperAdmin } = useAuthStore()
  const { t } = useI18n()

  const maxFiles = Number(config.public.MAX_FILES_IN_BATCH)
  const maxFileSize = Number(config.public.MAX_FILE_SIZE_IN_BYTES)

  const maxFilesRule = (files: File[] | File): string | true => {
    if (isSuperAdmin) {
      return true
    }

    if (!Array.isArray(files)) {
      files = [files]
    }

    if (!files.length || files.every((file) => !file)) return true // No files to validate.

    return files.length <= maxFiles || t("maxFiles", { max: maxFiles })
  }

  const maxFileSizeRule = (files: File[] | File): string | true => {
    if (isSuperAdmin) {
      return true
    }

    if (!Array.isArray(files)) {
      files = [files]
    }

    if (!files.length || files.every((file) => !file)) return true // No files to validate.

    return (
      files.every((file) => file.size <= maxFileSize) ||
      t("maxFileSize", {
        max: prettyBytes(maxFileSize),
      })
    )
  }

  const mimeMatchesAcceptRule =
    (accept?: string) =>
    (files: File[] | File): string | true => {
      const isFileTypeValid = (fileType: string, accept?: string) => {
        if (!accept) {
          return true
        }

        if (accept.endsWith("*")) {
          return fileType.startsWith(accept.replace("*", ""))
        }

        return accept.includes(fileType)
      }

      if (!Array.isArray(files)) {
        files = [files]
      }

      if (!files.length || files.every((file) => !file)) return true // No files to validate.

      return files.every((file: File) => isFileTypeValid(file.type, accept)) || t("invalidFile")
    }

  return {
    maxFiles,
    maxFileSize,
    mimeMatchesAcceptRule,
    maxFilesRule,
    maxFileSizeRule,
  }
}
